export const procedures = [

    {

        specialty: "Odontología General",

        categories: [

            {

                name: "Diagnóstico",

                procedures: [

                    {
                        id: "consulta_primera_vez",
                        name: "Consulta de primera vez",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "consulta_revision",
                        name: "Consulta de revisión",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "consulta_urgencia",
                        name: "Consulta de urgencia",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "segunda_opinion",
                        name: "Segunda opinión",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "valoracion_integral",
                        name: "Valoración integral",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Prevención",

                procedures: [

                    {
                        id: "profilaxis_adulto",
                        name: "Profilaxis adulto",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "profilaxis_infantil",
                        name: "Profilaxis infantil",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "detartraje_supragingival",
                        name: "Detartraje supragingival",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "detartraje_subgingival",
                        name: "Detartraje subgingival",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "control_placa",
                        name: "Control de placa dentobacteriana",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "instruccion_higiene",
                        name: "Instrucción de higiene oral",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "aplicacion_fluor",
                        name: "Aplicación tópica de flúor",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "selladores_fosetas_fisuras",
                        name: "Selladores de fosetas y fisuras",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    }

                ]

            },

            {

                name: "Operatoria Dental",

                procedures: [

                    {
                        id: "resina_clase_i",
                        name: "Resina Clase I",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "resina_clase_ii",
                        name: "Resina Clase II",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "resina_clase_iii",
                        name: "Resina Clase III",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "resina_clase_iv",
                        name: "Resina Clase IV",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "resina_clase_v",
                        name: "Resina Clase V",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "resina_clase_vi",
                        name: "Resina Clase VI",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "ionomero_vidrio",
                        name: "Restauración con ionómero de vidrio",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "reconstruccion_coronal",
                        name: "Reconstrucción coronaria",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "cementado_provisional",
                        name: "Cementado provisional",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Urgencias",

                procedures: [

                    {
                        id: "manejo_dolor_dental",
                        name: "Manejo de dolor dental",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "drenaje_absceso",
                        name: "Drenaje de absceso",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "trauma_dentoalveolar",
                        name: "Atención de trauma dentoalveolar",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "recementado_corona",
                        name: "Recementado de corona",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "recementado_puente",
                        name: "Recementado de puente",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },  

    {

        specialty: "Endodoncia",

        categories: [

            {

                name: "Tratamientos",

                procedures: [

                    {
                        id: "recubrimiento_pulpar_indirecto",
                        name: "Recubrimiento pulpar indirecto",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "recubrimiento_pulpar_directo",
                        name: "Recubrimiento pulpar directo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "pulpotomia_temporal",
                        name: "Pulpotomía en diente temporal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "pulpotomia_permanente",
                        name: "Pulpotomía en diente permanente",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "pulpectomia_temporal",
                        name: "Pulpectomía en diente temporal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "pulpectomia_permanente",
                        name: "Pulpectomía en diente permanente",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "endodoncia_incisivo",
                        name: "Endodoncia en incisivo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "endodoncia_canino",
                        name: "Endodoncia en canino",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "endodoncia_premolar",
                        name: "Endodoncia en premolar",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "endodoncia_molar",
                        name: "Endodoncia en molar",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Retratamientos",

                procedures: [

                    {
                        id: "retratamiento_incisivo",
                        name: "Retratamiento endodóntico en incisivo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "retratamiento_canino",
                        name: "Retratamiento endodóntico en canino",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "retratamiento_premolar",
                        name: "Retratamiento endodóntico en premolar",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "retratamiento_molar",
                        name: "Retratamiento endodóntico en molar",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Procedimientos Complementarios",

                procedures: [

                    {
                        id: "apexificacion",
                        name: "Apexificación",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "apicoformacion",
                        name: "Apicoformación",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "apicectomia",
                        name: "Apicectomía",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "eliminacion_poste",
                        name: "Retiro de poste intrarradicular",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "localizacion_conducto",
                        name: "Localización de conducto calcificado",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "reparacion_perforacion",
                        name: "Reparación de perforación radicular",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "remocion_instrumento_fracturado",
                        name: "Remoción de instrumento fracturado",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "blanqueamiento_interno",
                        name: "Blanqueamiento interno",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Periodoncia",

        categories: [

            {

                name: "Diagnóstico",

                procedures: [

                    {
                        id: "valoracion_periodontal",
                        name: "Valoración periodontal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "sondeo_periodontal",
                        name: "Sondeo periodontal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Tratamientos No Quirúrgicos",

                procedures: [

                    {
                        id: "profilaxis_periodontal",
                        name: "Profilaxis periodontal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "raspado_cuadrante",
                        name: "Raspado y alisado radicular por cuadrante",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "raspado_arcada",
                        name: "Raspado y alisado radicular por arcada",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "raspado_boca_completa",
                        name: "Raspado y alisado radicular de boca completa",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "curetaje_gingival",
                        name: "Curetaje gingival",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "irrigacion_subgingival",
                        name: "Irrigación subgingival",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Cirugía Periodontal",

                procedures: [

                    {
                        id: "gingivectomia",
                        name: "Gingivectomía",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "gingivoplastia",
                        name: "Gingivoplastia",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "colgajo_periodontal",
                        name: "Cirugía de colgajo periodontal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "alargamiento_corona",
                        name: "Alargamiento de corona clínica",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "regeneracion_tisular_guiada",
                        name: "Regeneración tisular guiada",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "regeneracion_osea_guiada",
                        name: "Regeneración ósea guiada",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "injerto_oseo_periodontal",
                        name: "Injerto óseo periodontal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "injerto_tejido_conectivo",
                        name: "Injerto de tejido conectivo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "injerto_gingival_libre",
                        name: "Injerto gingival libre",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "frenilectomia",
                        name: "Frenilectomía",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "frenotomia",
                        name: "Frenotomía",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Mantenimiento",

                procedures: [

                    {
                        id: "mantenimiento_periodontal",
                        name: "Mantenimiento periodontal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "reevaluacion_periodontal",
                        name: "Reevaluación periodontal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Cirugía Oral",

        categories: [

            {

                name: "Extracciones",

                procedures: [

                    {
                        id: "extraccion_temporal",
                        name: "Extracción de diente temporal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "extraccion_permanente",
                        name: "Extracción de diente permanente",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "extraccion_restos_radiculares",
                        name: "Extracción de restos radiculares",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "extraccion_quirurgica",
                        name: "Extracción quirúrgica",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "odontectomia",
                        name: "Odontectomía",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Terceros Molares",

                procedures: [

                    {
                        id: "extraccion_tercer_molar_erupcionado",
                        name: "Extracción de tercer molar erupcionado",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "extraccion_tercer_molar_semirretenido",
                        name: "Extracción de tercer molar semirretenido",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "extraccion_tercer_molar_retenido",
                        name: "Extracción de tercer molar retenido",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Cirugía Preprotésica",

                procedures: [

                    {
                        id: "alveoloplastia",
                        name: "Alveoloplastia",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "regularizacion_reborde",
                        name: "Regularización de reborde alveolar",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "vestibuloplastia",
                        name: "Vestibuloplastia",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "torus_maxilar",
                        name: "Remoción de torus maxilar",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "torus_mandibular",
                        name: "Remoción de torus mandibular",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Tejidos Blandos",

                procedures: [

                    {
                        id: "biopsia_incisional",
                        name: "Biopsia incisional",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "biopsia_excisional",
                        name: "Biopsia excisional",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "escision_lesion",
                        name: "Escisión de lesión de tejidos blandos",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "marsupializacion",
                        name: "Marsupialización",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "enucleacion_quiste",
                        name: "Enucleación de quiste",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Procedimientos Complementarios",

                procedures: [

                    {
                        id: "exposicion_diente_retenido",
                        name: "Exposición quirúrgica de diente retenido",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "colocacion_hemostatico",
                        name: "Colocación de agente hemostático",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "sutura_postquirurgica",
                        name: "Sutura postquirúrgica",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "retiro_suturas",
                        name: "Retiro de suturas",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_alveolitis",
                        name: "Tratamiento de alveolitis",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Implantología",

        categories: [

            {

                name: "Planeación",

                procedures: [

                    {
                        id: "valoracion_implantes",
                        name: "Valoración para implantes",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "planeacion_implantologica",
                        name: "Planeación implantológica",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "guia_quirurgica",
                        name: "Guía quirúrgica para implantes",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Cirugía de Implantes",

                procedures: [

                    {
                        id: "implante_unitario",
                        name: "Colocación de implante unitario",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "implantes_multiples",
                        name: "Colocación de implantes múltiples",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "segunda_fase_implante",
                        name: "Segunda fase quirúrgica",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "retiro_implante",
                        name: "Retiro de implante",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Regeneración Ósea",

                procedures: [

                    {
                        id: "injerto_oseo_autologo",
                        name: "Injerto óseo autólogo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "injerto_oseo_xenoinjerto",
                        name: "Injerto óseo xenoinjerto",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "injerto_oseo_aloinjerto",
                        name: "Injerto óseo aloinjerto",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "membrana_regeneracion",
                        name: "Colocación de membrana de regeneración",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "regeneracion_osea_guiada_implantes",
                        name: "Regeneración ósea guiada",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Elevación de Seno",

                procedures: [

                    {
                        id: "elevacion_seno_cerrada",
                        name: "Elevación de seno maxilar cerrada",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "elevacion_seno_abierta",
                        name: "Elevación de seno maxilar abierta",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Componentes Protésicos",

                procedures: [

                    {
                        id: "colocacion_cicatrizador",
                        name: "Colocación de tornillo cicatrizador",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "retiro_cicatrizador",
                        name: "Retiro de tornillo cicatrizador",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "colocacion_pilar",
                        name: "Colocación de pilar protésico",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "carga_inmediata",
                        name: "Carga inmediata",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Mantenimiento",

                procedures: [

                    {
                        id: "mantenimiento_implantes",
                        name: "Mantenimiento de implantes",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "tratamiento_periimplantitis",
                        name: "Tratamiento de periimplantitis",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "tratamiento_mucositis",
                        name: "Tratamiento de mucositis periimplantaria",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Prótesis",

        categories: [

            {

                name: "Prótesis Fija",

                procedures: [

                    {
                        id: "corona_provisional",
                        name: "Corona provisional",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "corona_metalica",
                        name: "Corona metálica",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "corona_metal_porcelana",
                        name: "Corona metal-porcelana",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "corona_libre_metal",
                        name: "Corona libre de metal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "corona_zirconia",
                        name: "Corona de zirconia",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "puente_fijo",
                        name: "Puente fijo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "poste_muñon",
                        name: "Poste y muñón",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "recementado_corona_definitiva",
                        name: "Recementado de corona definitiva",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Incrustaciones",

                procedures: [

                    {
                        id: "inlay",
                        name: "Inlay",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "onlay",
                        name: "Onlay",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "overlay",
                        name: "Overlay",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "endocrown",
                        name: "Endocrown",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Carillas",

                procedures: [

                    {
                        id: "carilla_resina",
                        name: "Carilla de resina",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "carilla_porcelana",
                        name: "Carilla de porcelana",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    }

                ]

            },

            {

                name: "Prótesis Parcial Removible",

                procedures: [

                    {
                        id: "protesis_parcial_acrilica",
                        name: "Prótesis parcial acrílica",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "protesis_parcial_flexible",
                        name: "Prótesis parcial flexible",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "protesis_parcial_metalica",
                        name: "Prótesis parcial metálica",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Prótesis Total",

                procedures: [

                    {
                        id: "protesis_total_superior",
                        name: "Prótesis total superior",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "protesis_total_inferior",
                        name: "Prótesis total inferior",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "protesis_total_bimaxilar",
                        name: "Prótesis total bimaxilar",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Reparaciones y Ajustes",

                procedures: [

                    {
                        id: "rebase_directo",
                        name: "Rebase directo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "rebase_indirecto",
                        name: "Rebase indirecto",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "reparacion_protesis",
                        name: "Reparación de prótesis",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "ajuste_protesis",
                        name: "Ajuste de prótesis",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "acondicionamiento_tisular",
                        name: "Acondicionamiento tisular",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Odontopediatría",

        categories: [

            {

                name: "Prevención",

                procedures: [

                    {
                        id: "consulta_odontopediatrica",
                        name: "Consulta odontopediátrica",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "profilaxis_infantil_especialidad",
                        name: "Profilaxis infantil",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "aplicacion_fluor_infantil",
                        name: "Aplicación tópica de flúor",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "selladores_infantiles",
                        name: "Selladores de fosetas y fisuras",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    }

                ]

            },

            {

                name: "Operatoria",

                procedures: [

                    {
                        id: "resina_temporal",
                        name: "Resina en diente temporal",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "ionomero_temporal",
                        name: "Restauración con ionómero en diente temporal",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "corona_acero_cromo",
                        name: "Corona de acero cromo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "corona_estetica_infantil",
                        name: "Corona estética infantil",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Mantenedores de Espacio",

                procedures: [

                    {
                        id: "mantenedor_fijo",
                        name: "Mantenedor de espacio fijo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "mantenedor_removible",
                        name: "Mantenedor de espacio removible",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "recementado_mantenedor",
                        name: "Recementado de mantenedor de espacio",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Exodoncias",

                procedures: [

                    {
                        id: "extraccion_temporal_simple",
                        name: "Extracción de diente temporal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "extraccion_temporal_compleja",
                        name: "Extracción compleja de diente temporal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Traumatismos",

                procedures: [

                    {
                        id: "manejo_traumatismo_temporal",
                        name: "Manejo de traumatismo en dentición temporal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "ferulizacion_infantil",
                        name: "Ferulización dental infantil",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Control",

                procedures: [

                    {
                        id: "control_odontopediatrico",
                        name: "Control odontopediátrico",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "reevaluacion_odontopediatrica",
                        name: "Reevaluación odontopediátrica",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Ortodoncia",

        categories: [

            {

                name: "Diagnóstico",

                procedures: [

                    {
                        id: "valoracion_ortodoncia",
                        name: "Valoración de ortodoncia",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "analisis_ortodontico",
                        name: "Análisis ortodóntico",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "plan_tratamiento_ortodoncia",
                        name: "Plan de tratamiento de ortodoncia",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Inicio de Tratamiento",

                procedures: [

                    {
                        id: "colocacion_brackets_metalicos",
                        name: "Colocación de brackets metálicos",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "colocacion_brackets_esteticos",
                        name: "Colocación de brackets estéticos",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "colocacion_brackets_autoligado",
                        name: "Colocación de brackets de autoligado",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "cementado_banda",
                        name: "Cementado de banda ortodóntica",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Controles",

                procedures: [

                    {
                        id: "ajuste_ortodoncia",
                        name: "Ajuste de ortodoncia",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "cambio_arco",
                        name: "Cambio de arco",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "cambio_ligas",
                        name: "Cambio de ligas",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "reposicion_bracket",
                        name: "Reposición de bracket",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "recementado_banda",
                        name: "Recementado de banda",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "colocacion_resorte",
                        name: "Colocación de resorte",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "cadena_elastica",
                        name: "Colocación de cadena elástica",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Anclaje Temporal",

                procedures: [

                    {
                        id: "colocacion_microtornillo",
                        name: "Colocación de microtornillo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "retiro_microtornillo",
                        name: "Retiro de microtornillo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Retención",

                procedures: [

                    {
                        id: "retenedor_fijo",
                        name: "Retenedor fijo",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "retenedor_removible",
                        name: "Retenedor removible",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "retenedor_essix",
                        name: "Retenedor Essix",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "reparacion_retenedor",
                        name: "Reparación de retenedor",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Finalización",

                procedures: [

                    {
                        id: "retiro_brackets",
                        name: "Retiro de brackets",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "pulido_postortodoncia",
                        name: "Pulido postortodoncia",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Estética Dental",

        categories: [

            {

                name: "Blanqueamiento",

                procedures: [

                    {
                        id: "blanqueamiento_consultorio",
                        name: "Blanqueamiento dental en consultorio",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "blanqueamiento_casa",
                        name: "Blanqueamiento dental ambulatorio",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "blanqueamiento_combinado",
                        name: "Blanqueamiento combinado",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "retoque_blanqueamiento",
                        name: "Retoque de blanqueamiento",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Diseño de Sonrisa",

                procedures: [

                    {
                        id: "diseno_sonrisa",
                        name: "Diseño de sonrisa",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "mockup_estetico",
                        name: "Mock-up estético",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "encerado_diagnostico",
                        name: "Encerado diagnóstico",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Contorneado Dental",

                procedures: [

                    {
                        id: "contorneado_estetico",
                        name: "Contorneado estético dental",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "remodelado_bordes",
                        name: "Remodelado de bordes incisales",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "cierre_diastema_resina",
                        name: "Cierre de diastema con resina",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    }

                ]

            },

            {

                name: "Microabrasión e Infiltración",

                procedures: [

                    {
                        id: "microabrasion_esmalte",
                        name: "Microabrasión del esmalte",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "infiltracion_resina",
                        name: "Infiltración de resina para lesiones de manchas blancas",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    }

                ]

            },

            {

                name: "Estética Gingival",

                procedures: [

                    {
                        id: "gingivoplastia_estetica",
                        name: "Gingivoplastia estética",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "gingivectomia_estetica",
                        name: "Gingivectomía estética",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Radiología",

        categories: [

            {

                name: "Radiografía Intraoral",

                procedures: [

                    {
                        id: "radiografia_periapical",
                        name: "Radiografía periapical",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "radiografia_interproximal",
                        name: "Radiografía interproximal (Bite-Wing)",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "radiografia_oclusal",
                        name: "Radiografía oclusal",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Radiografía Extraoral",

                procedures: [

                    {
                        id: "radiografia_panoramica",
                        name: "Radiografía panorámica",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "serie_radiografica_completa",
                        name: "Serie radiográfica completa",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "cefalometria_lateral",
                        name: "Cefalometría lateral",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "cefalometria_posteroanterior",
                        name: "Cefalometría posteroanterior",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "radiografia_carpo",
                        name: "Radiografía de carpo",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Tomografía",

                procedures: [

                    {
                        id: "cbct_arcada",
                        name: "Tomografía CBCT por arcada",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "cbct_maxilar",
                        name: "Tomografía CBCT de maxilar",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "cbct_mandibula",
                        name: "Tomografía CBCT de mandíbula",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "cbct_completa",
                        name: "Tomografía CBCT de ambos maxilares",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Fotografía Clínica",

                procedures: [

                    {
                        id: "fotografia_intraoral",
                        name: "Fotografía clínica intraoral",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "fotografia_extraoral",
                        name: "Fotografía clínica extraoral",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "fotografia_seguimiento",
                        name: "Fotografía de seguimiento clínico",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Patología Bucal",

        categories: [

            {

                name: "Diagnóstico",

                procedures: [

                    {
                        id: "valoracion_patologia_bucal",
                        name: "Valoración de patología bucal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "interconsulta_patologia",
                        name: "Interconsulta de patología bucal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Biopsias",

                procedures: [

                    {
                        id: "biopsia_incisional_patologia",
                        name: "Biopsia incisional",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "biopsia_excisional_patologia",
                        name: "Biopsia excisional",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "biopsia_por_puncion",
                        name: "Biopsia por punción",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Lesiones de Tejidos Blandos",

                procedures: [

                    {
                        id: "evaluacion_lesion_mucosa",
                        name: "Evaluación de lesión de mucosa oral",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "escision_fibroma",
                        name: "Escisión de fibroma",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "escision_mucocele",
                        name: "Escisión de mucocele",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "escision_papiloma",
                        name: "Escisión de papiloma",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Quistes y Tumores",

                procedures: [

                    {
                        id: "valoracion_quiste",
                        name: "Valoración de quiste odontogénico",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "enucleacion_quiste_patologia",
                        name: "Enucleación de quiste",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "seguimiento_lesion",
                        name: "Seguimiento de lesión oral",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Estudios Complementarios",

                procedures: [

                    {
                        id: "toma_muestra_histopatologia",
                        name: "Toma de muestra para histopatología",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "revision_resultado_biopsia",
                        name: "Revisión de resultado histopatológico",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "referencia_oncologia",
                        name: "Referencia a oncología",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Medicina Bucal",

        categories: [

            {

                name: "Consulta",

                procedures: [

                    {
                        id: "consulta_medicina_bucal",
                        name: "Consulta de medicina bucal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "interconsulta_medicina_bucal",
                        name: "Interconsulta de medicina bucal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "seguimiento_medicina_bucal",
                        name: "Seguimiento de medicina bucal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Enfermedades de la Mucosa Oral",

                procedures: [

                    {
                        id: "manejo_ulceras_orales",
                        name: "Manejo de úlceras orales",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_liquen_plano",
                        name: "Manejo de liquen plano oral",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_candidiasis",
                        name: "Manejo de candidiasis oral",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_estomatitis",
                        name: "Manejo de estomatitis",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_queilitis",
                        name: "Manejo de queilitis",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Glándulas Salivales",

                procedures: [

                    {
                        id: "valoracion_glandulas_salivales",
                        name: "Valoración de glándulas salivales",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_xerostomia",
                        name: "Manejo de xerostomía",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_sialoadenitis",
                        name: "Manejo de sialoadenitis",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_sialolitiasis",
                        name: "Manejo de sialolitiasis",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Manifestaciones Sistémicas",

                procedures: [

                    {
                        id: "valoracion_manifestaciones_sistemicas",
                        name: "Valoración de manifestaciones sistémicas en cavidad oral",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_paciente_medicamente_comprometido",
                        name: "Manejo de paciente médicamente comprometido",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "referencia_medica",
                        name: "Referencia médica",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Dolor Orofacial",

                procedures: [

                    {
                        id: "valoracion_dolor_orofacial",
                        name: "Valoración de dolor orofacial",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_neuralgia_trigemino",
                        name: "Manejo de neuralgia del trigémino",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_ardor_bucal",
                        name: "Manejo de síndrome de ardor bucal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "ATM y Oclusión",

        categories: [

            {

                name: "Diagnóstico",

                procedures: [

                    {
                        id: "valoracion_atm",
                        name: "Valoración de ATM",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "analisis_oclusal",
                        name: "Análisis oclusal",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "registro_mordida",
                        name: "Registro de mordida",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Ajuste Oclusal",

                procedures: [

                    {
                        id: "ajuste_oclusal_selectivo",
                        name: "Ajuste oclusal selectivo",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    },

                    {
                        id: "equilibrado_oclusal",
                        name: "Equilibrado oclusal",
                        requiresOdontogram: true,
                        allowsSurfaces: true
                    }

                ]

            },

            {

                name: "Férulas",

                procedures: [

                    {
                        id: "ferula_descarga",
                        name: "Férula de descarga",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "ferula_miorrelajante",
                        name: "Férula miorrelajante",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "ferula_estabilizacion",
                        name: "Férula de estabilización",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "ajuste_ferula",
                        name: "Ajuste de férula",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "reparacion_ferula",
                        name: "Reparación de férula",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Trastornos Temporomandibulares",

                procedures: [

                    {
                        id: "manejo_bruxismo",
                        name: "Manejo de bruxismo",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_disfuncion_atm",
                        name: "Manejo de disfunción temporomandibular",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "manejo_dolor_miofascial",
                        name: "Manejo de dolor miofascial",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "seguimiento_atm",
                        name: "Seguimiento de ATM",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Sedación y Anestesiología",

        categories: [

            {

                name: "Valoración Preoperatoria",

                procedures: [

                    {
                        id: "valoracion_preoperatoria",
                        name: "Valoración preoperatoria",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "valoracion_riesgo_anestesico",
                        name: "Valoración de riesgo anestésico",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Anestesia Local",

                procedures: [

                    {
                        id: "anestesia_local",
                        name: "Aplicación de anestesia local",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "anestesia_troncular",
                        name: "Bloqueo troncular",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "anestesia_intraligamentaria",
                        name: "Anestesia intraligamentaria",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    },

                    {
                        id: "anestesia_intraosea",
                        name: "Anestesia intraósea",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Sedación",

                procedures: [

                    {
                        id: "sedacion_inhalada",
                        name: "Sedación inhalada con óxido nitroso",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "sedacion_oral",
                        name: "Sedación oral",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "sedacion_intravenosa",
                        name: "Sedación intravenosa",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Monitoreo",

                procedures: [

                    {
                        id: "monitoreo_transoperatorio",
                        name: "Monitoreo transoperatorio",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "recuperacion_postanestesica",
                        name: "Recuperación postanestésica",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Anestesia General",

                procedures: [

                    {
                        id: "anestesia_general",
                        name: "Anestesia general",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    },

    {

        specialty: "Administrativos y Complementarios",

        categories: [

            {

                name: "Consultas",

                procedures: [

                    {
                        id: "consulta_domicilio",
                        name: "Consulta a domicilio",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "consulta_hospitalaria",
                        name: "Consulta hospitalaria",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "segunda_opinion_especializada",
                        name: "Segunda opinión especializada",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Interconsultas y Referencias",

                procedures: [

                    {
                        id: "interconsulta_especialidad",
                        name: "Interconsulta con otra especialidad",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "referencia_especialista",
                        name: "Referencia a especialista",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "contrarreferencia",
                        name: "Contrarreferencia",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Documentación",

                procedures: [

                    {
                        id: "certificado_dental",
                        name: "Certificado dental",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "constancia_tratamiento",
                        name: "Constancia de tratamiento",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "informe_clinico",
                        name: "Informe clínico",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "dictamen_odontologico",
                        name: "Dictamen odontológico",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Urgencias",

                procedures: [

                    {
                        id: "atencion_urgencia",
                        name: "Atención de urgencia odontológica",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "control_postoperatorio",
                        name: "Control postoperatorio",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "retiro_material",
                        name: "Retiro de material provisional",
                        requiresOdontogram: true,
                        allowsSurfaces: false
                    }

                ]

            },

            {

                name: "Otros Servicios",

                procedures: [

                    {
                        id: "teleconsulta",
                        name: "Teleconsulta",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "asesoria_tratamiento",
                        name: "Asesoría sobre tratamiento",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    },

                    {
                        id: "evaluacion_multidisciplinaria",
                        name: "Evaluación multidisciplinaria",
                        requiresOdontogram: false,
                        allowsSurfaces: false
                    }

                ]

            }

        ]

    }

];